import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import bladesLogo from "../../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../../index.css";
import { ContentContainer } from "../../SessionSection";
import { useEffect } from "react";
import NavDistricts from "./NavDistricts";
import NavCampaign from "./NavCampaign";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "",
    text: (
      <div className="morkBorgFont morkBorgTitleText">
        <p align="center">
          <NavDistricts />

          <img
            src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-text-whitecrown.webp"
            alt="Whitecrown"
          />
        </p>
        <strong>
          The sprawling estates of the Lord Governor, Hunter Commander, Master
          Warden, and Doskvol Academy.
        </strong>{" "}
        <em>
          Whitecrown sits atop a grand peak on the island across North Hook
          channel from the city proper. From this lofty height, the Lord
          Governor’s stronghold oversees all, flanked by the grand estates of
          the most powerful nobility and the extravagantly appointed campus of
          Doskvol Academy. Whitecrown is a rich and rarefied world unto
          itself—most citizens live out their entire lives in the city without
          ever once crossing the bridge to the glittering spires of wealth and
          power there.
        </em>
        <img
          src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-header-whitecrown.webp"
          alt="Whitecrown"
        />
        <table className="district-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>District Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td valign="top">
                <strong>Scene:</strong> Imperial soldiers parade outside the
                stronghold, astride their armored steeds, gleaming lances held
                high. Trainee crews run drills on a leviathan hunter ship docked
                for refitting. The lavish carriages and electroplasmic coaches
                of the fabulously wealthy glide by, carrying their privileged
                passengers to luxurious destinations.
                <br />
                <strong>Streets:</strong> Broad, polished stone, brightly lit to
                near daylight by a riot of warm electric lights. Whitecrown
                Boulevard, Swancrest Avenue.
                <br />
                <strong>Buildings:</strong> Grand, elegant facades; landscaped
                terraces, balconies, and elevated walkways connecting bright
                marble buildings with inlaid platinum and gold details.
                <br />
                <strong>Factions:</strong>
                <ul>
                  <li>1. Imperial Military</li>
                  <li>2. Leviathan Hunters</li>
                </ul>
              </td>
              <td valign="top">
                <img
                  src="https://www.smokeraven.com/static/html/assets/blades-in-the-dark/places/district-traits-white-crown.webp"
                  alt="Whitecrown district traits"
                />
                <br />
                <em>
                  Most engagement rolls suffer <strong>-2d</strong> due to heavy
                  Bluecoat patrols. Operations against the nobility in
                  Whitecrown are considered on “hostile turf” for the purpose of
                  generating <strong>heat</strong>.
                </em>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <h1>Whitecrown Locations</h1>
        <strong>
          <u>Lord Governor&apos;s Stronghold</u>
        </strong>
        : The Emperor originally commissioned this stronghold as a garrison for
        the Imperial Military stationed at North Hook prior to the invasion of
        Skovlan. It now houses the Lord Governor, their family, and governmental
        aides as well.
        <br />
        <br />
        <strong>
          <u>Doskvol Academy</u>
        </strong>
        : Hailed as one of the finer institutions of learning in the Empire, the
        school is most wellknown as the instructional facility for the leviathan
        hunter captains and their senior officers. Training cruises for new
        recruits are conducted year-round to replace the poor souls lost in the
        hunts.
        <br />
        <br />
        <strong>
          <u>Master Warden&apos;s Estate</u>
        </strong>
        : This gigantic, fortified manor is home to the Commander of the Spirit
        Wardens and is their primary training facility. It’s said that some
        spirits are not destroyed at Bellweather—but are brought here instead
        for some unknown purpose.
        <br />
        <br />
        <strong>
          <u>North Hook Lighthouse</u>
        </strong>
        : This ancient structure has been converted into an electro-plasmic
        apparatus capable of providing a navigation beacon for hundreds of miles
        into the darkness of the Void Sea around Duskwall.
        <p>
          <a href="#pageTop">Back to Top</a>
        </p>
      </div>
    ),
  },
];

const BITDClasses_Districts_Whitecrown = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">Blades in the Dark: Campaign</h1>
                <p className="lead leadExtra">
                  <NavCampaign />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <a name="pageTop" href="#pageTop">
                {" "}
              </a>
              <img
                src={sectionDivider}
                className="BITD-section-divider"
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDClasses_Districts_Whitecrown;
